import YouTubeFacade from './YouTubeFacade';

const VIDEOS = [
  { id: 'PDyvnE-tF7s', title: 'Testimonio alumno 1' },
  { id: 'zYy4NuUIGlM', title: 'Testimonio alumno 2' },
  { id: 'UHTIrY_OUrU', title: 'Testimonio alumno 3' },
];

export default function VideoTestimonials() {
  return (
    <section className="pt-12 pb-20 px-6 bg-white border-t border-neutral-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-neutral-900 text-center mb-3 tracking-tight">
          Testimonios de alumnos
        </h2>
        <p className="text-neutral-500 text-center text-base sm:text-lg mb-10">
          Lo que dicen quienes ya transformaron su trabajo con datos
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map((video) => (
            <div
              key={video.id}
              className="relative aspect-video rounded-xl overflow-hidden bg-neutral-900 shadow-md ring-1 ring-neutral-200/60 transition-shadow hover:shadow-lg"
            >
              <YouTubeFacade videoId={video.id} title={video.title} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
